import {ProductCode} from "@/modules/Segmentation/models/ProductCode";

interface IDriver {
    age: number,
    kbm: number;
    experience: number;
}

export class SegmentationInfo {
    transportType: string;
    clientType: string;
    purposeType: string;
    isMultiDrive: boolean;
    carModelException: string;
    drivers: IDriver[];
    power: number;
    permittedMass: number;
    coefficientTerritory: number;
    periodUse: number;
    yearManufacture: number;
    nameException: string;
    clientAddressCode: string;
    productCode: ProductCode;
    orgInn: string;
    isActive: boolean;
    isUseSupplementary: boolean;

    constructor(dto?: ISegmentationInfoDto)
    constructor(
        transportType?: string,
        clientType?: string,
        purposeType?: string,
        isMultiDrive?: boolean,
        carModelException?: string,
        drivers?: IDriver[],
        power?: number,
        permittedMass?: number,
        coefficientTerritory?: number,
        periodUse?: number,
        yearManufacture?: number,
        nameException?: string,
        clientAddressCode?: string,
        productCode?: ProductCode,
        orgInn?: string,
        isActive?: boolean,
        isUseSupplementary?: boolean,
    )
    constructor(
        dtoOrTransportType: ISegmentationInfoDto | string = "",
        clientType: string = "",
        purposeType: string = "",
        isMultiDrive: boolean = false,
        carModelException: string = "",
        drivers: IDriver[] = [],
        power: number = 0,
        permittedMass: number = 0,
        coefficientTerritory: number = 0,
        periodUse: number = 0,
        yearManufacture: number = 0,
        nameException: string = "",
        clientAddressCode: string = "",
        productCode: ProductCode = new ProductCode(),
        orgInn: string = "",
        isActive: boolean = false,
        isUseSupplementary: boolean = false,
    ) {
        if (typeof dtoOrTransportType !== "string") {
            this.transportType = dtoOrTransportType.transportType;
            this.clientType = dtoOrTransportType.clientType;
            this.purposeType = dtoOrTransportType.purposeType;
            this.isMultiDrive = dtoOrTransportType.isMultiDrive;
            this.carModelException = dtoOrTransportType.carModelException;
            this.power = dtoOrTransportType.power;
            this.permittedMass = dtoOrTransportType.permittedMass;
            this.coefficientTerritory = dtoOrTransportType.coefficientTerritory;
            this.periodUse = dtoOrTransportType.periodUse;
            this.yearManufacture = dtoOrTransportType.yearManufacture;
            this.drivers = dtoOrTransportType.drivers !== undefined
                ? dtoOrTransportType.drivers.map((i) => ({
                    age: i.age,
                    experience: i.fullYearsDriverExperience,
                    kbm: i.kbm,
                }))
                : [];
            this.nameException = dtoOrTransportType.nameException ?? "";
            this.clientAddressCode = dtoOrTransportType.clientAddressCode;
            this.productCode = new ProductCode(dtoOrTransportType.productCode);
            this.orgInn = dtoOrTransportType.orgInn;
            this.isActive = dtoOrTransportType.isActive;
            this.isUseSupplementary = dtoOrTransportType.isUseSupplementary;
        } else {
            this.transportType = dtoOrTransportType;
            this.clientType = clientType;
            this.purposeType = purposeType;
            this.isMultiDrive = isMultiDrive;
            this.carModelException = carModelException;
            this.power = power;
            this.permittedMass = permittedMass;
            this.coefficientTerritory = coefficientTerritory;
            this.periodUse = periodUse;
            this.yearManufacture = yearManufacture;
            this.drivers = drivers;
            this.nameException = nameException;
            this.clientAddressCode = clientAddressCode;
            this.productCode = productCode;
            this.orgInn = orgInn;
            this.isActive = isActive;
            this.isUseSupplementary = isUseSupplementary;
        }
    }

    get clientName(): string {
        return this.nameException || "Юр. лицо";
    }
}

export type ISegmentationInfoDto = Readonly<{
    "drivers"?: Array<{
        "age": number,
        "kbm": number;
        "fullYearsDriverExperience": number;
    }>;
    "usagePeriods": number[];
    "transportType": string;
    "clientType": string;
    "purposeType": string;
    "isMultiDrive": boolean;
    "carModelException": string;
    "power": number;
    "permittedMass": number;
    "coefficientTerritory": number;
    "periodUse": number;
    "yearManufacture": number;
    "nameException"?: string;
    "clientAddressCode": string;
    "productCode": string;
    "orgInn": string;
    "isActive": boolean,
    "isUseSupplementary": boolean;
}>;
